import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./vendor/rootReducer";
import { persistReducer, persistStore } from 'redux-persist';

import localforage from 'localforage';
import { supportFrameSessionId } from '../common/services/support-frame';

const persistConfig = {
    key: 'root',
    storage: localforage,
    // The catalogue is queried page by page now. Persisting a product list
    // wrote thousands of products to IndexedDB on every change, for nothing.
    blacklist: ['products'],
  };

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({ reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
 });

export const persistor = persistStore(store)

// A support session frame shows a vendor's portal inside the super admin's
// page, which shares this storage: it reads what is kept but never writes, so
// nothing of the vendor's state outlives the frame or lands in the admin's.
if (supportFrameSessionId()) persistor.pause()
